import React from 'react';
// import PropTypes from 'prop-types';
import {ViewPaymentMethods} from '../Checkout/viewPaymentMethods';
import {SELECTOR_FULFILLMENT_CURRENT} from '../../redux/selectors/fulfillments';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';

PaymentMethod.propTypes = {};

function PaymentMethod() {
  const delivery = useSelector(SELECTOR_FULFILLMENT_CURRENT);

  const history = useHistory();

  React.useEffect(() => {
    if (!delivery) history.push('/checkout/delivery');
  }, [delivery, history]);
  return <ViewPaymentMethods />;
}

export default PaymentMethod;
